import {SET_UBICACION } from "../ActionTypes";


const ubicacion = (state, { payload, type }) => {
  switch (type) {
    case SET_UBICACION:
      return {
        ...state,
        ubicacion: {
          ...state.ubicacion,
          loading: false,
          error: false,
          data: payload,
        },
      };

    default:
      return state;
  }
};

export default ubicacion;
